module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.support', {
            url: '/support',
            views: {
                'left-panel@': {
                    template: '<wow-accessibility-nav-links class="onesite-base"></wow-accessibility-nav-links>'
                }
            },
            data: {
                authenticate: false,
                analytics: `bws:web:support`
            }
        })
        .state('shop.support.accessibility', {
            url: '/accessibility',
            views: {
                'center-panel@': {
                    template: '<wow-my-account-shopper-accessibility></wow-my-account-shopper-accessibility>'
                }
            },
            data: {
                authenticate: false,
                analytics: `bws:web:accessibility`
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/accessibility.js
 **/